import { registerDecorator, ValidationOptions } from 'class-validator';

const EMAIL_BOX_VALIDATION_REGEX = /^[a-z0-9]+[a-z0-9._%+-]*$/i;

export const IsEmailNameValid = (validationOptions?: ValidationOptions) => (object: Object, propertyName: string) => {
  registerDecorator({
    name: 'isEmailNameValid',
    target: object.constructor,
    propertyName: propertyName,
    options: validationOptions,
    validator: {
      validate: validateEmailName,
      defaultMessage: () => 'Please enter a valid email name',
    },
  });
};

export const validateEmailName = (nameToValidate: string) => EMAIL_BOX_VALIDATION_REGEX.test(nameToValidate);
